export default "__VITE_ASSET__BuH2cqMe__"